<div class="data-table-container">
    <!-- Search and Filters -->
    <div class="row mb-3 align-items-center" *ngIf="config.showSearch || config.showFilters">
        <div class="col-md-6" *ngIf="config.showSearch">
            <div class="search-input-wrapper">
                <i class="bi bi-search search-icon"></i>
                <input type="text" class="form-control modern-search-input" placeholder="Search..."
                    [value]="searchTerm" (input)="onSearch($event)">
            </div>
        </div>
        <div class="col-md-6" *ngIf="config.showFilters">
            <!-- Filter dropdown would go here -->
        </div>
    </div>

    <!-- Loading Overlay -->
    <div *ngIf="loading" class="loader-overlay">
        <div class="spinner-border" style="color: #667eea"></div>
    </div>

    <!-- Data Table -->
    <div class="modern-table-wrapper">
        <table class="modern-table">
            <thead>
                <tr>
                    <th *ngFor="let column of config.columns"
                        [class.sortable-header]="column.sortable"
                        (click)="column.sortable ? onSort(column.key) : null">
                        <div class="header-content">
                            <span>{{column.label}}</span>
                            <i *ngIf="column.sortable && sortColumn !== column.key"
                               class="bi bi-arrow-down-up"></i>
                            <i *ngIf="sortColumn === column.key && sortDirection === 'asc'"
                               class="bi bi-arrow-up"></i>
                            <i *ngIf="sortColumn === column.key && sortDirection === 'desc'"
                               class="bi bi-arrow-down"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of filteredData">
                    <td *ngFor="let column of config.columns">
                        <ng-container [ngSwitch]="column.type">
                            <span *ngSwitchCase="'date'">{{item[column.key] | date:'short'}}</span>
                            <span *ngSwitchCase="'number'">{{item[column.key] | number}}</span>
                            <span *ngSwitchCase="'boolean'">
                                <i *ngIf="item[column.key]" class="bi bi-check-circle text-success"></i>
                                <i *ngIf="!item[column.key]" class="bi bi-x-circle text-danger"></i>
                            </span>
                            <span *ngSwitchDefault>{{item[column.key]}}</span>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="!filteredData.length && !loading" class="text-center py-5">
        <i class="bi bi-inbox text-muted" style="font-size: 2.5rem;"></i>
        <p class="text-muted mt-2">{{config.emptyMessage || 'No data found.'}}</p>
    </div>

    <!-- Pagination -->
    <nav *ngIf="config.showPagination && totalItems > (config.pageSize || 10)" aria-label="Data pagination">
        <ul class="pagination justify-content-center mt-3">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="onPageChange(currentPage - 1)" href="#">
                    <i class="bi bi-chevron-left"></i> Previous
                </a>
            </li>
            <li class="page-item" *ngFor="let page of getPagesArray(); let i = index"
                [class.active]="currentPage === i + 1">
                <a class="page-link" (click)="onPageChange(i + 1)" href="#">{{i + 1}}</a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
                <a class="page-link" (click)="onPageChange(currentPage + 1)" href="#">
                    Next <i class="bi bi-chevron-right"></i>
                </a>
            </li>
        </ul>
    </nav>
</div>